import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Product } from "../../entities/Product";
import { motion } from "framer-motion";

export default function ProductRecommendations({ currentProductId, category }) {
  const [recommendations, setRecommendations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadRecommendations();
  }, [currentProductId, category]);

  const loadRecommendations = async () => {
    setIsLoading(true);
    try {
      // Get 3 products from the same category, excluding the current product
      const data = await Product.filter(
        { category: category },
        "-created_date",
        3
      );
      setRecommendations(data.filter(p => p.id !== currentProductId));
    } catch (error) {
      console.error('Error loading recommendations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="page-wrap py-14">
        <div>
          <h2 className="text-3xl tracking-wide mb-8">Style With</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="panel p-4 space-y-4">
                <div className="aspect-[4/5] bg-[var(--accent-soft)] animate-pulse rounded-xl" />
                <div className="h-4 w-2/3 bg-[var(--accent-soft)] animate-pulse rounded" />
                <div className="h-4 w-1/3 bg-[var(--accent-soft)] animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!recommendations.length) {
    return null;
  }

  return (
    <div className="page-wrap py-14 border-t border-[var(--line)] mt-14">
      <div>
        <h2 className="text-3xl tracking-wide mb-8">Style With</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {recommendations.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Link to={`/product/${product.id}`} className="block group">
                <div className="panel relative aspect-[4/5] overflow-hidden bg-[var(--accent-soft)]">
                  {product.limited_edition && (
                    <div className="absolute top-4 left-4 z-10 bg-[var(--accent)] text-white px-3 py-1 text-xs uppercase tracking-[0.1em] rounded-full">
                      LIMITED EDITION
                    </div>
                  )}
                  <img 
                    src={product.images?.[0]}
                    alt={product.name}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-lg mt-4 mb-1 tracking-wide">{product.name}</h3>
                <p className="text-[var(--muted)]">${product.price?.toFixed(2)}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
